import { useCareTeamMembers } from '../../../api/careTeam/useCareTeamMembers';
import { useAuth } from '../../../hooks';

const useCareTeamMember = () => {
  const { user: authenticatedProvider } = useAuth();
  const { careTeamMemberData } = useCareTeamMembers();

  const providerOptions = careTeamMemberData
    ?.filter((member) => member.capacity > 0)
    .map((member) => ({
      label: member.display_name,
      value: member.id,
      healthieId: member.healthie_id,
    }));

  // this checks that the user which is authenticated is a care team member as the
  // initialSelectedProviderOption should not be defined if the authenticated user is a coach or user
  const initialSelectedProviderOption = providerOptions?.find(
    (opt) => opt.value === authenticatedProvider?.id
  );

  return {
    initialSelectedProviderId: initialSelectedProviderOption?.value,
    providerOptions,
    // true once the fetch has resolved (even if the authenticated user isn't a provider)
    isCareTeamDataLoaded: providerOptions !== undefined,
  };
};

export default useCareTeamMember;
